
  import { mapState } from 'vuex'
  import autoScrollToActivity from '~/mixins/pages/mission-control/autoScrollToActivity'
  import missions from '~/mixins/pages/mission-control/missions'
  import vipSettings from '~/mixins/pages/mission-control/vipSettings'
  export default {
    name: 'Theme2MissionDesktopActivityMissionPage',
    mixins: [missions, vipSettings, autoScrollToActivity],
    data() {
      return {
        selectedMission: '',
        displayTermAndConditions: false,
        missionActivitiesLoading: false
      }
    },
    computed: {
      ...mapState({
        mission: state => state.activities['mission-reward'].mission,
        missionsLoading: state => state.activities['mission-reward'].missionsLoading,
        getMissionByIdLoading: state => state.activities['mission-reward'].getMissionByIdLoading,
        missions: state => state.activities['mission-reward'].missions,
        layoutType: state => state.activities['mission-reward'].missionLayoutType,
        defaultCurrency: state => state.settings.defaultCurrency,
        missionsSettings: state => state.activities['mission-reward'].missionsSettings
      }),
      missionActivities() {
        return this.mission.mission_dates || []
      },
      missionsList() {
        const missionType = this.$route.query.mission_type
        return this.missions[missionType] || []
      },
      missionsByMissionTypeLoading() {
        const missionType = this.$route.query.mission_type
        return this.missionsLoading[missionType] || false
      },
      guidelineActivities() {
        return this.mission.activities || []
      },
      eventType() {
        if (!this.mission) return ''
        const missionType = this.mission.mission_type
        if (missionType === 1) return 'weekly'
        if (missionType === 2) return 'monthly'
        if (missionType === 3) return 'event'
        if (missionType === 4) return 'guideline'
        return ''
      },
      isRunning() {
        if (!this.mission?.start_date || !this.mission?.end_date) {
          return false
        }
        const startDate = this.$dayjs(this.mission.start_date).startOf('day')
        const endDate = this.$dayjs(this.mission.end_date).endOf('day')
        return this.$dayjs().isSameOrAfter(startDate) && this.$dayjs().isSameOrBefore(endDate)
      }
    },
    watch: {
      async '$route.query'(value) {
        if (value) {
          const missionId = value?.mission_id
          const missionType = value?.mission_type
          this.missionActivitiesLoading = true
          // Fetch here
          if (missionId) {
            // Fetch the mission detail
            await this.$store.dispatch('activities/mission-reward/getMissionById', missionId)
            this.selectedMission = missionId
          }
          if (missionType && !this.missionsList?.length) {
            await this.$store.dispatch('activities/mission-reward/getMissions', {
              mission_type: missionType,
              currency: this.defaultCurrency
            })
          }
          this.missionActivitiesLoading = false
          this.disabledAutoScrolling = false
          this.onScrollingDownToSelectedActivity()
        }
      },
      mission(value) {
        this.onScrollingDownToSelectedActivity()
      }
    },
    mounted() {
      this.selectedMission = this.$route.query.mission_id
      this.getVipSettings() // It's from mixins->vipSettings.js
      this.getPlayerVipTier() //  mixins->vipSettings.js
    },
    methods: {
      onChangeMission(item) {
        this.selectedMission = item.id
        const existingQuery = this.$route.query
        if (existingQuery) {
          delete existingQuery.activity_id
        }
        this.$router.push({
          query: { ...existingQuery, mission_id: item.id }
        })
      }
    }
  }
